import { useQuery } from '@tanstack/react-query'
import { topFreeFeaturesKeys } from '@!/Api/queryKeys'
import { getTopFreeFeaturesApi } from '@!/Api/freeFeatures'
import { useAtom } from 'jotai'
import { safeSearchAtom } from '@!/atoms/safeSearchAtom'

export const useTopFreeFeatures = (device, genreTabName) => {
  const [safeSearch] = useAtom(safeSearchAtom)

  const { data } = useQuery({
    queryKey: topFreeFeaturesKeys.filtered(safeSearch, device),
    queryFn: async () => {
      return await getTopFreeFeaturesApi(safeSearch, device)
    },
    enabled: genreTabName == null, // ジャンルタブ未選択時のみ有効化
    refetchOnWindowFocus: false,
  })

  return data
}
